module.exports = __webpack_public_path__ + "static/linetoday-kp-c022c1431be293de68d7d92a68938270.jpeg";